<template>
  <div class="jm-message" v-if="status">
    <div class="bg" v-if="type === 'confirm'">
      <div class="confirm">
        <div>
          <div class="img">
            <img src="../assets/sign-in/icon-error-else.svg" alt="">
          </div>
          <div class="text">
            {{text}}
          </div>
          <div class="button">
            <jm-button :text="$t('goto-sign-in')" @click="click"></jm-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg confirm-success" v-else-if="type === 'confirm-success'">
      <div class="confirm">
        <div class="timeout">
          <div class="text">{{time}}s</div>
          <div class="icon" @click="click">
            <img src="../assets/sign-in/icon-close.svg" alt="">
          </div>
        </div>
        <div>
          <div class="img">
            <img src="../assets/retrieve/icon-found.svg" alt="">
          </div>
          <div class="name">{{text}}</div>
          <div class="text" v-html="$t('success-text', {phone: phone, password: password})"></div>
          <div class="button">
            <jm-button :text="$t('now-in')+' >>'" @click="click"></jm-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main" :class="type" v-else>
      <div class="icon icon_error" v-if="type === 'error'">
        <img src="../assets/sign-in/icon-error-1.svg" alt="">
      </div>
      <div class="icon icon_success" v-if="type === 'success'">
        <img src="../assets/retrieve/icon-success.svg" alt="">
      </div>
      <div class="text">
        {{text}}
      </div>
    </div>
  </div>
</template>
<script>
import JmButton from './JmButton.vue'
export default {
  name: 'jm-message',
  props: {
    status: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'error'
    },
    type: {
      type: String,
      default: 'error'
    },
    phone: {
      type: String,
      default: ''
    },
    password: {
      type: String,
      default: ''
    },
    click: {
      type: Function,
      default: () => {
      }
    }
  },
  data () {
    return {
      time: 10,
      successTimeout: ''
    }
  },
  watch: {
    status () {
      const t = this
      if (t.status && t.type === 'confirm-success') {
        t.time = 5
        clearTimeout(t.successTimeout)
        t.timeDown()
      }
    }
  },
  computed: {
  },
  beforeMount () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    timeDown () {
      const t = this
      if (t.time > 0) {
        t.successTimeout = setTimeout(() => {
          t.time--
          t.timeDown()
        }, 1000)
      } else {
        clearTimeout(t.successTimeout)
        t.click()
      }
    }
  },
  components: {
    JmButton
  }
}
</script>
<style scoped>
  .jm-message {
    position: fixed;
    top: calc(17 / 16 * 1rem);
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    min-width: calc(400 / 16 * 1rem);
  }
  .main {
    display: flex;
    align-items: center;
    width: calc(400 / 16 * 1rem);
    height: calc(45 / 16 * 1rem);
    padding: 0 calc(40 / 16 * 1rem);
    box-sizing: border-box;
    border-radius: 2px;
  }
  .mobile-phone .jm-message {
    position: fixed;
    top: calc(15 / 375 * 100vw);
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    min-width: 0;
  }
  .mobile-phone .jm-message .main {
    display: flex;
    align-items: center;
    width: calc(300 / 375 * 100vw);
    height: calc(30 / 375 * 100vw);
    padding: 0 calc(10 / 375 * 100vw);
    box-sizing: border-box;
    border-radius: 2px;
    font-size: calc(14 / 375 * 100vw);
  }
  .error {
    border: 1px solid #FF0000;
    background-color: #FFE5E5;
    color: #FF0000;
  }
  .success {
    border: 1px solid #588AFF;
    background-color: #EAF4FE;
    color: #588AFF;
  }
  .jm-message .icon {
    width: calc(25 / 16 * 1rem);
    margin-right: calc(10 / 16 * 1rem);
  }
  .mobile-phone .jm-message .icon {
    width: calc(18 / 375 * 100vw);
    margin-right: calc(5 / 375 * 100vw);
  }
  .jm-message .confirm-success .timeout {
    display: flex;
    align-items: center;
    color: #999999;
    height: calc(20 / 16 * 1rem);
  }
  .jm-message .confirm-success .timeout .text {
  }
  .jm-message .confirm-success .icon {
    width: calc(20 / 16 * 1rem);
    margin-right: calc(0 / 16 * 1rem);
    margin-left: calc(10 / 16 * 1rem);
  }
  .jm-message .icon_success {
    width: calc(29 / 16 * 1rem);
  }
  .mobile-phone .jm-message .icon_success {
    width: calc(18 / 375 * 100vw);
  }
  .bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    min-width: 1024px;
  }
  .mobile-phone .bg {
    min-width: 100%;
  }
  .confirm {
    width: calc(516 / 16 * 1rem);
    background-color: #fff;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: calc(90 / 16 * 1rem) calc(30 / 16 * 1rem);
    font-size: calc(20 / 16 * 1rem);
    text-align: center;
    box-sizing: border-box;
    position: relative;
  }
  .timeout {
    position: absolute;
    top: calc(30 / 16 * 1rem);
    right: calc(40 / 16 * 1rem);
  }
  .confirm-success .confirm {
    padding: calc(90 / 16 * 1rem) calc(100 / 16 * 1rem);
  }
  .mobile-phone .confirm {
    width: 85%;
    padding: calc(25 / 375 * 100vw) calc(15 / 375 * 100vw);
    font-size: calc(16 / 375 * 100vw);
  }
  .confirm .img {
    display: inline-block;
    width: calc(120 / 16 * 1rem);
    margin-bottom: calc(20 / 16 * 1rem);
  }
  .confirm-success .confirm .img {
    margin-bottom: 0;
  }
  .confirm-success .confirm .name {
    font-size: calc(24 / 16 * 1rem);
    font-weight: 700;
    padding-bottom: calc(25 / 16 * 1rem);
  }
  .mobile-phone .confirm .img {
    width: calc(100 / 375 * 100vw);
    margin-bottom: calc(10 / 375 * 100vw);
  }
  .confirm .text {
    text-align: left;
  }
  .confirm-success .confirm .text {
    text-align: center;
  }
  .confirm .button {
    margin-top: calc(65 / 16 * 1rem);
    display: inline-block;
    width: calc(250 / 16 * 1rem);
  }
  .confirm-success .confirm .button {
    margin-top: calc(50 / 16 * 1rem);
  }
  .mobile-phone .confirm .button {
    margin-top: calc(30 / 375 * 100vw);
    width: calc(150 / 375 * 100vw);
  }
</style>
